import React from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { Brightness4 as DarkModeIcon, Brightness7 as LightModeIcon, SettingsBrightness as SystemModeIcon } from '@mui/icons-material';
import { useThemeContext } from './ThemeProvider';

interface ThemeToggleProps {
  placement?: 'topbar' | 'sidebar' | 'menuitem';
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ placement = 'topbar' }) => {
  const { mode, setMode } = useThemeContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleModeChange = (newMode: 'light' | 'dark' | 'system') => {
    setMode(newMode);
    handleClose();
  };
  
  const renderThemeIcon = () => {
    switch (mode) {
      case 'dark':
        return <DarkModeIcon />;
      case 'system':
        return <SystemModeIcon />;
      default:
        return <LightModeIcon />;
    }
  };
  
  // If it's a menu item, render just the menu items without the toggle button
  if (placement === 'menuitem') {
    return (
      <>
        <MenuItem onClick={() => handleModeChange('light')}>
          <ListItemIcon>
            <LightModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Light Mode" />
        </MenuItem>
        <MenuItem onClick={() => handleModeChange('dark')}>
          <ListItemIcon>
            <DarkModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Dark Mode" />
        </MenuItem>
        <MenuItem onClick={() => handleModeChange('system')}>
          <ListItemIcon>
            <SystemModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="System Default" />
        </MenuItem>
      </>
    );
  }
  
  return (
    <>
      <Tooltip title="Change theme">
        <IconButton
          onClick={handleClick}
          size="medium"
          color="inherit"
          aria-label="Toggle theme mode"
        >
          {renderThemeIcon()}
        </IconButton>
      </Tooltip>
      <Menu
        id="theme-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleModeChange('light')}>
          <ListItemIcon>
            <LightModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Light Mode" />
        </MenuItem>
        <MenuItem onClick={() => handleModeChange('dark')}>
          <ListItemIcon>
            <DarkModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Dark Mode" />
        </MenuItem>
        <MenuItem onClick={() => handleModeChange('system')}>
          <ListItemIcon>
            <SystemModeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="System Default" />
        </MenuItem>
      </Menu>
    </>
  );
}; 